import { useEffect } from "react";

/**
 * Sets `document.title` for the duration this component is mounted.
 * On unmount, restores the previous title (avoids stale titles when
 * navigating quickly between routes).
 *
 * Usage:
 *   usePageTitle("Cart");           // → "Cart | HerbKranti"
 *   usePageTitle("Cart", { raw: true }); // → "Cart" (no suffix)
 */
const SUFFIX = "HerbKranti";
const BRAND_FULL = "HerbKranti Wellness | Premium Ayurvedic Wellness";

export const usePageTitle = (title, opts = {}) => {
  useEffect(() => {
    const prev = document.title;
    if (!title) {
      document.title = BRAND_FULL;
    } else if (opts.raw) {
      document.title = title;
    } else {
      document.title = `${title} | ${SUFFIX}`;
    }
    return () => {
      document.title = prev;
    };
  }, [title, opts.raw]);
};

export default usePageTitle;
